import React from "react";

import SubcategoryList from "./SubcategoryList";
import Attachments from "./Attachments";

class Subcategory extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            category: props.category,
            subcatName: props.subcatName,
            referenceId: props.referenceId,
            subcategoryLevel: props.subcategoryLevel

        }
    }

    componentDidMount(){

    }

    componentDidUpdate(prevProps){
        if(prevProps.category !== this.props.category || prevProps.referenceId !== this.props.referenceId || prevProps.subcategoryLevel !== this.props.subcategoryLevel){
            this.setState({
                category: this.props.category,
                subcatName: this.props.subcatName,
                referenceId: this.props.referenceId,
                subcategoryLevel: this.props.subcategoryLevel
            });
        }
    }

    render() {
        const { category, subcatName, referenceId, subcategoryLevel } = this.state;
        return (
            <div className="tab-pane fade show active" id="serv" role="tabpanel" aria-labelledby="serv-tab">
                <div className="box-card">
                    <div className="row">
                        <div className="col-md-12">
                                <SubcategoryList
                                    category={category}
                                    subcatName={subcatName}
                                    referenceId={referenceId}
                                    subcategoryLevel={subcategoryLevel}
                                />
                        </div>
                    </div>
                    <Attachments 
                        category={referenceId}
                    />
                </div>
            </div>
        );
    }
  }
  
export default Subcategory;  